import {
  Col,
  DeleteButton,
  EditButton,
  List,
  Row,
  Space,
  Table,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import type { ColumnsType } from "antd/es/table";
import React from "react";

export const OptionReleasePricingList: React.FC<
  IResourceComponentsProps
> = () => {
  const { tableProps }: any = useTable<any>({
    resource: "release-pricing",
    initialPageSize: 100,
  });

  const columns: ColumnsType<any> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record: any) => <TextField value={record.name} />,
    },
    {
      title: "Min Tracks",
      dataIndex: "minTracks",
      key: "minTracks",
      render: (_, record) => <TextField value={record.minTracks} />,
    },
    {
      title: "Max Tracks",
      dataIndex: "maxTracks",
      key: "maxTracks",
      render: (_, record) => <TextField value={record.maxTracks} />,
    },
    {
      title: "Min Price",
      dataIndex: "minPrice",
      key: "minPrice",
      render: (_, record) => <TextField value={record.minPrice} />,
    },
    {
      title: "Max Price",
      dataIndex: "maxPrice",
      key: "maxPrice",
      render: (_, record) => <TextField value={record.maxPrice} />,
    },
    {
      title: "Labels",
      dataIndex: "labels",
      key: "labels",
      render: (_, record) => (
        <TextField
          value={(record?.labels || [])
            ?.map((label: any) => label?.name)
            ?.join(", ")}
        />
      ),
    },
    {
      title: "Is Active",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <TextField value={record.isActive ? "True" : "False"} />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record._id} />
          <DeleteButton hideText size="small" recordItemId={record._id} />
        </Space>
      ),
    },
  ];

  return (
    <List>
      <Row style={{ display: "block" }}>
        {/* <Col>
                    <Form layout='vertical' {...searchFormProps}>
                        <Form.Item label='Search' name='search' style={{ width: '50%' }} initialValue=''>
                            <Input placeholder='Name, Biography' prefix={<Icons.SearchOutlined />} />
                        </Form.Item>
                    </Form>
                </Col> */}
        <Col>
          <Table
            {...tableProps}
            pagination={{
              ...tableProps?.pagination,
              showSizeChanger: true,
            }}
            columns={columns}
            rowKey="id"
          />
        </Col>
      </Row>
    </List>
  );
};
